<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar
      :handle-delete="del"
      :handle-reset="resetForm"
      :handle-submit="onSendForm"
      >

        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50"  >
            <h1><v-icon large>mdi-account-group</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>

    <ProfilForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProfilForm from '../../components/profiluser/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'ProfilUser';

export default {
  name: 'ProfilUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProfilForm
  },

  computed: {
    ...mapFields('profil', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('profil', ['find']),

  },

  methods: {
    ...mapActions('profil', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),


  }
};
</script>
